import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import styles from './Toggle.css';

class Toggle extends React.Component {
  render() {
    return (
      <button
        type="button"
        className={`btn btn-default ${styles.wrapper}`}
        onClick={this.props.onClick}
      >
        {this._label()} <i className="fa fa-angle-down" />
      </button>
    );
  }

  _label = () => {
    const { startDate, endDate } = this.props;
    if (!startDate || !endDate) {
      return 'Loading...';
    }
    const momentStart = moment(startDate);
    const momentEnd = moment(endDate);
    if (momentStart.isSame(momentEnd, 'days')) {
      return momentStart.format('D/M/YYYY');
    }
    return `${momentStart.format('D/M/YYYY')} - ${momentEnd.format(
      'D/M/YYYY'
    )}`;
  };
}

Toggle.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  onClick: PropTypes.func,
};

export default Toggle;
